import type { LoginOptions } from "@dotcom/oauthjs";
import { envConfig } from "./envConfigs";
const promptArray: Record<string, string> = {
  "/support/issue-reporting/payment-refund": "select_billing_account",
  "/support/rewards": "none",
};
export const oauthConfig: LoginOptions = {
  allowIframeLoginWithoutPromptNone: true,
  authOpts: {
    prompt:
      promptArray[
        window.location.pathname.lastIndexOf("/") === window.location.pathname.length - 1
          ? window.location.pathname.substring(0, window.location.pathname.lastIndexOf("/")).toLowerCase()
          : window.location.pathname.toLowerCase()
      ] || "none",
    redirect_uri: `${
      window.location.pathname.lastIndexOf("/") === window.location.pathname.length - 1
        ? window.location.pathname.substring(0, window.location.pathname.lastIndexOf("/")).toLowerCase()
        : window.location.pathname.toLowerCase()
    }/`,
  },
  authorizeUrl: "https://oauth.xfinity.com/oauth/authorize",
  iframeRedirectUri: `${
    window.location.pathname.lastIndexOf("/") === window.location.pathname.length - 1
      ? window.location.pathname.substring(0, window.location.pathname.lastIndexOf("/")).toLowerCase()
      : window.location.pathname.toLowerCase()
  }/token.html`,
  redirect: true,
  useIframe: false,
  ...envConfig.oauthConfig,
};
